/* Create Your Own: clay cutter geometry. Units are inches. Outlines are closed point lists, counter-clockwise. */
(function () {
  'use strict';
  var LIB = window.CYO_CUTTER_LIBRARY || [];
  var RIM = 1.5;                        /* face (presser / top of form) = cutter size minus 1.5" */
  var MIN_SIZE = 1, MAX_SIZE = 11, SET_MIN = 3;

  var SHAPES = [
    { id: 'circle', name: 'Circle / oval' },
    { id: 'rect', name: 'Square / rectangle' },
    { id: 'rounded', name: 'Rounded rectangle' },
    { id: 'tri', name: 'Soft triangle' }
  ];
  /* edge profiles: f(u) on one repeat, 0 = outermost, 1 = deepest cut */
  var EDGES = [
    { id: 'straight', name: 'Straight' },
    { id: 'wavy', name: 'Wavy', f: function (u) { return (1 - Math.cos(2 * Math.PI * u)) / 2; } },
    { id: 'scalloped', name: 'Scalloped', f: function (u) { var v = 2 * u - 1; return 1 - Math.sqrt(Math.max(0, 1 - v * v)); } },
    { id: 'crimped', name: 'Crimped', f: function (u) { return u < 0.5 ? 2 * u : 2 - 2 * u; } },
    { id: 'petal', name: 'Petal', f: function (u) { return 1 - Math.pow(Math.sin(Math.PI * u), 0.6); } }
  ];
  (window.CYO_PROFILE_EDGES || []).forEach(function (e) {
    var s = e.s, n = s.length;
    EDGES.push({ id: e.id, name: e.name, sig: true, f: function (u) { var x = (u % 1) * n, i = Math.floor(x), fr = x - i; return s[i % n] * (1 - fr) + s[(i + 1) % n] * fr; } });
  });
  var PRESSERS = [
    { id: 'match', name: 'Match cutter' }, { id: 'circle', name: 'Round' }, { id: 'rounded', name: 'Soft rectangle' },
    { id: 'tri', name: 'Soft triangle' }, { id: 'wavy', name: 'Soft wavy' }
  ];

  function edge(id) { return EDGES.find(function (e) { return e.id === id; }) || EDGES[0]; }
  function house(id) { return LIB.find(function (d) { return d.id === id; }) || null; }

  /* ---------- base shapes ---------- */
  function ellipse(w, l, n) { var p = []; for (var i = 0; i < n; i++) { var a = 2 * Math.PI * i / n; p.push([w / 2 * Math.cos(a), l / 2 * Math.sin(a)]); } return p; }
  function roundRect(w, l, r, n) {
    r = Math.min(r, w / 2, l / 2);
    var hw = w / 2 - r, hl = l / 2 - r, pts = [], per = 2 * (2 * hw + 2 * hl) + 2 * Math.PI * r;
    /* walk: right side, top-right corner, top, top-left corner, left, bottom-left, bottom, bottom-right */
    var path = [
      { t: 'L', a: [w / 2, -hl], b: [w / 2, hl] }, { t: 'A', c: [hw, hl], s: 0 },
      { t: 'L', a: [hw, l / 2], b: [-hw, l / 2] }, { t: 'A', c: [-hw, hl], s: Math.PI / 2 },
      { t: 'L', a: [-w / 2, hl], b: [-w / 2, -hl] }, { t: 'A', c: [-hw, -hl], s: Math.PI },
      { t: 'L', a: [-hw, -l / 2], b: [hw, -l / 2] }, { t: 'A', c: [hw, -hl], s: 3 * Math.PI / 2 }
    ];
    path.forEach(function (sg) {
      var len = sg.t === 'L' ? Math.hypot(sg.b[0] - sg.a[0], sg.b[1] - sg.a[1]) : Math.PI / 2 * r;
      var k = Math.max(1, Math.round(n * len / per));
      for (var i = 0; i < k; i++) {
        var t = i / k;
        if (sg.t === 'L') pts.push([sg.a[0] + (sg.b[0] - sg.a[0]) * t, sg.a[1] + (sg.b[1] - sg.a[1]) * t]);
        else { var ang = sg.s + t * Math.PI / 2; pts.push([sg.c[0] + r * Math.cos(ang), sg.c[1] + r * Math.sin(ang)]); }
      }
    });
    return pts;
  }
  function softTri(w, l, n) {
    /* rounded triangle: superellipse-style blend of an ellipse and a triangle, apex up */
    var pts = [];
    for (var i = 0; i < n; i++) {
      var a = 2 * Math.PI * i / n - Math.PI / 2;
      var r = 1 / (1 + 0.16 * Math.cos(3 * (a + Math.PI / 2)));
      pts.push([Math.cos(a) * r, Math.sin(a) * r]);
    }
    return fit(pts, w, l);
  }
  function fit(pts, w, l) {
    var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
    var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs), y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
    return pts.map(function (p) { return [(p[0] - (x0 + x1) / 2) / (x1 - x0) * w, (p[1] - (y0 + y1) / 2) / (y1 - y0) * l]; });
  }
  function parseD(d) {           /* library paths: absolute M then relative l segments on a 0..1000 grid */
    var nums = d.match(/-?\d+/g).map(Number), pts = [[nums[0], nums[1]]];
    for (var i = 2; i + 1 < nums.length; i += 2) { var q = pts[pts.length - 1]; pts.push([q[0] + nums[i], q[1] + nums[i + 1]]); }
    return pts;
  }
  var parsed = {};
  function houseBase(h, w, l) {
    if (!parsed[h.id]) parsed[h.id] = parseD(h.d).map(function (p) { return [p[0], -p[1]]; });
    return ccw(fit(parsed[h.id], w, l));
  }
  function area(p) { var a = 0; for (var i = 0; i < p.length; i++) { var q = p[(i + 1) % p.length]; a += p[i][0] * q[1] - q[0] * p[i][1]; } return a / 2; }
  function ccw(p) { return area(p) < 0 ? p.slice().reverse() : p; }

  /* resample a closed outline evenly by arc length */
  function resample(p, n) {
    var L = [0], tot = 0;
    for (var i = 0; i < p.length; i++) { var q = p[(i + 1) % p.length]; tot += Math.hypot(q[0] - p[i][0], q[1] - p[i][1]); L.push(tot); }
    var out = [], j = 0;
    for (var k = 0; k < n; k++) {
      var s = tot * k / n;
      while (L[j + 1] < s) j++;
      var a = p[j], b = p[(j + 1) % p.length], t = (s - L[j]) / Math.max(1e-9, L[j + 1] - L[j]);
      out.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]);
    }
    return { pts: out, len: tot };
  }
  /* push an outline inward along its normals by depth * f(u); repeats chosen so the pattern closes exactly */
  function applyEdge(base, eid, size, depth) {
    var E = edge(eid); if (!E.f) return base;
    var r = resample(base, 1440), pts = r.pts, n = pts.length;
    var reps = Math.max(3, Math.round(r.len / Math.max(0.2, size)));
    return pts.map(function (p, i) {
      var a = pts[(i - 1 + n) % n], b = pts[(i + 1) % n], tx = b[0] - a[0], ty = b[1] - a[1], m = Math.hypot(tx, ty) || 1;
      var nx = -ty / m, ny = tx / m;             /* inward normal for a counter-clockwise outline */
      var d = depth * E.f((i / n) * reps % 1);
      return [p[0] + nx * d, p[1] + ny * d];
    });
  }

  function base(o) {
    if (o.src === 'house') { var h = house(o.id); return h ? houseBase(h, o.w, o.l) : []; }
    if (o.shape === 'circle') return ellipse(o.w, o.l, 720);
    if (o.shape === 'rect') return roundRect(o.w, o.l, Math.min(0.25, Math.min(o.w, o.l) * 0.1), 720);
    if (o.shape === 'rounded') return roundRect(o.w, o.l, Math.min(o.w, o.l) * 0.22, 720);
    if (o.shape === 'tri') return ccw(softTri(o.w, o.l, 720));
    return ellipse(o.w, o.l, 720);
  }
  /* round off sharp points: average neighbours within ~r inches along the outline, two passes */
  function soften(p, r) {
    p = resample(p, 720).pts;
    var n = p.length, L = 0;
    for (var i = 0; i < n; i++) { var q = p[(i + 1) % n]; L += Math.hypot(q[0] - p[i][0], q[1] - p[i][1]); }
    var k = Math.max(1, Math.round(r / (L / n)));
    for (var pass = 0; pass < 2; pass++) {
      p = p.map(function (_, i) { var sx = 0, sy = 0; for (var j = -k; j <= k; j++) { var q = p[(i + j + n) % n]; sx += q[0]; sy += q[1]; } return [sx / (2 * k + 1), sy / (2 * k + 1)]; });
    }
    return p;
  }
  /* round any corner tighter than minR (inches), inside or outside, and leave smooth stretches alone */
  var MIN_R = 0.1;
  function roundCorners(p, minR) {
    minR = minR || MIN_R;
    p = resample(p, 900).pts;
    var n = p.length, L = 0;
    for (var i = 0; i < n; i++) { var q = p[(i + 1) % n]; L += Math.hypot(q[0] - p[i][0], q[1] - p[i][1]); }
    var step = L / n, k = Math.max(1, Math.round(minR * 0.7 / step));
    function radius(a, b, c) {
      var ab = Math.hypot(b[0] - a[0], b[1] - a[1]), bc = Math.hypot(c[0] - b[0], c[1] - b[1]), ca = Math.hypot(a[0] - c[0], a[1] - c[1]);
      var cr = Math.abs((b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]));
      return cr < 1e-9 ? 1e9 : ab * bc * ca / (2 * cr);
    }
    for (var it = 0; it < 40; it++) {
      var hit = 0, q2 = p.slice();
      for (var j = 0; j < n; j++) {
        var a = p[(j - k + n) % n], b = p[j], c = p[(j + k) % n];
        if (radius(a, b, c) < minR) {
          hit++;
          var sx = 0, sy = 0;
          for (var m = -k; m <= k; m++) { var r = p[(j + m + n) % n]; sx += r[0]; sy += r[1]; }
          q2[j] = [sx / (2 * k + 1), sy / (2 * k + 1)];
        }
      }
      p = q2; if (!hit) break;
    }
    return p;
  }
  function outline(o) {
    var b = ccw(base(o));
    if (o.src === 'house' || !o.edge || o.edge === 'straight') return roundCorners(b);
    return roundCorners(soften(applyEdge(b, o.edge, o.edgeSize || 0.6, o.edgeDepth || 0.15), 0.04));
  }

  /* ---------- presser / form face ---------- */
  function face(o) { return { w: Math.max(0, o.w - RIM), l: Math.max(0, o.l - RIM) }; }
  function canSet(o) { return Math.min(o.w, o.l) >= SET_MIN; }
  function presserOutline(o, kind) { return roundCorners(presserRaw(o, kind), 0.15); }
  function presserRaw(o, kind) {
    var f = face(o); kind = kind || 'match';
    if (kind === 'match') return o.src === 'house' ? soften(houseBase(house(o.id), f.w, f.l), 0.06) : (o.shape === 'rect' ? roundRect(f.w, f.l, Math.min(0.3, Math.min(f.w, f.l) * 0.15), 360) : soften(ccw(base(Object.assign({}, o, f))), 0.06));
    if (kind === 'circle') return ellipse(f.w, f.l, 360);
    if (kind === 'rounded') return roundRect(f.w, f.l, Math.min(f.w, f.l) * 0.3, 360);
    if (kind === 'tri') return ccw(softTri(f.w, f.l, 360));
    if (kind === 'wavy') return applyEdge(ellipse(f.w, f.l, 360), 'wavy', 0.9, 0.08);
    return ellipse(f.w, f.l, 360);
  }

  /* ---------- pricing tiers by longest side ---------- */
  var CUTTER_TIERS = [[2.5, 'Up to 2.5"'], [4.5, 'Up to 4.5"'], [6, 'Up to 6"'], [6.5, 'Up to 6.5"'], [8, 'Up to 8"'], [9.5, 'Up to 9.5"'], [11, 'Up to 11"']];
  var SET_TIERS = [[5, 'For cutters up to 5"'], [6.5, 'For cutters up to 6.5"'], [8, 'For cutters up to 8"'], [9.5, 'For cutters up to 9.5"'], [11, 'For cutters up to 11"']];
  function tier(list, o) { var L = Math.max(o.w, o.l) - 0.01; var t = list.find(function (x) { return L <= x[0]; }); return t ? t[1] : list[list.length - 1][1]; }

  /* stencils that fit, from the studio size guide: rim = cutter size, face = cutter minus 1.5" */
  function fmt(n) { return (Math.round(n * 4) / 4).toString().replace(/\.0$/, '') + '"'; }
  function dims(w, l) { return Math.abs(w - l) < 0.01 ? fmt(w) : fmt(Math.min(w, l)) + ' x ' + fmt(Math.max(w, l)); }
  function stencils(o) {
    var f = face(o), out = [];
    out.push(['Full coverage', dims(o.w, o.l) + ' face stencil']);
    if (canSet(o)) {
      out.push(['Face only', dims(f.w, f.l) + ' face stencil']);
      out.push(['Rim only', dims(o.w, o.l) + ' rim stencil']);
      out.push(['Face + rim', dims(f.w, f.l) + ' face + ' + dims(o.w, o.l) + ' rim']);
    }
    return out;
  }

  /* ---------- drawing ---------- */
  var COLORS = { 'Hot Pink': '#E8478B', 'Glitter': '#B9B4C7', 'Bright Orange': '#F26A1B', 'Teal': '#1E9FA0', 'Charcoal': '#3A3A3A' };
  function pathD(pts, k, ox, oy) {
    return pts.map(function (p, i) { return (i ? 'L' : 'M') + ((p[0] + ox) * k).toFixed(1) + ',' + ((oy - p[1]) * k).toFixed(1); }).join('') + 'Z';
  }
  function svg(o, opts) {
    opts = opts || {};
    var k = 100, pad = 0.4, W = o.w + pad * 2, L = o.l + pad * 2 + (opts.thumb ? 0 : 0.35);
    var col = COLORS[opts.color] || '#3A3A3A', out = outline(o), ox = W / 2, oy = pad + o.l / 2;
    var s = '<svg class="' + (opts.thumb ? 'cyo__thumb-svg' : 'cyo__cut-svg') + '" viewBox="0 0 ' + (W * k).toFixed(0) + ' ' + (L * k).toFixed(0) + '" role="img" aria-label="Cutter preview">';
    if (opts.form && canSet(o)) s += '<path d="' + pathD(presserOutline(o, 'match'), k, ox, oy) + '" fill="rgba(0,0,0,.05)" stroke="#999" stroke-width="' + (0.03 * k) + '" stroke-dasharray="' + (0.08 * k) + ' ' + (0.06 * k) + '"/>';
    if (opts.presser && canSet(o)) s += '<path d="' + pathD(presserOutline(o, opts.presser), k, ox, oy) + '" fill="' + col + '" fill-opacity=".18" stroke="' + col + '" stroke-width="' + (0.03 * k) + '"/>';
    s += '<path d="' + pathD(out, k, ox, oy) + '" fill="none" stroke="' + col + '" stroke-width="' + ((opts.thumb ? 0.12 : 0.09) * Math.max(1, Math.max(o.w, o.l) / 5) * k) + '" stroke-linejoin="round"/>';
    if (!opts.thumb) s += '<text x="' + (W * k / 2) + '" y="' + ((L - 0.08) * k) + '" text-anchor="middle" font-size="' + (0.24 * k) + '" fill="#5B5D57" font-family="inherit">' + dims(o.w, o.l) + '</text>';
    return s + '</svg>';
  }
  function exportSVG(o, presserKind) {
    var k = 72, pad = 0.25, W = o.w + pad * 2, L = o.l + pad * 2, ox = W / 2, oy = pad + o.l / 2;
    var s = '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + W.toFixed(3) + 'in" height="' + L.toFixed(3) + 'in" viewBox="0 0 ' + (W * k).toFixed(2) + ' ' + (L * k).toFixed(2) + '">' +
      '<desc>' + label(o) + ' | ' + dims(o.w, o.l) + ' cutting edge</desc>' +
      '<path id="cutter" d="' + pathD(outline(o), k, ox, oy) + '" fill="none" stroke="#ec1c24" stroke-width="0.72"/>';
    if (presserKind && canSet(o)) s += '<path id="presser" d="' + pathD(presserOutline(o, presserKind), k, ox, oy) + '" fill="none" stroke="#0000ff" stroke-width="0.72"/>';
    return s + '</svg>';
  }
  function label(o) {
    if (o.src === 'house') { var h = house(o.id); return h ? h.name : 'Cutter'; }
    var sh = SHAPES.find(function (x) { return x.id === o.shape; }), e = edge(o.edge);
    return (e.id === 'straight' ? '' : e.name + ' ') + (sh ? sh.name.split(' / ')[0].toLowerCase() : 'cutter');
  }

  window.CYOCutter = {
    LIB: LIB, soften: soften, SHAPES: SHAPES, EDGES: EDGES, PRESSERS: PRESSERS, RIM: RIM, MIN_SIZE: MIN_SIZE, MAX_SIZE: MAX_SIZE, SET_MIN: SET_MIN,
    house: house, outline: outline, face: face, canSet: canSet, presserOutline: presserOutline,
    cutterTier: function (o) { return tier(CUTTER_TIERS, o); }, setTier: function (o) { return tier(SET_TIERS, o); },
    stencils: stencils, dims: dims, svg: svg, exportSVG: exportSVG, label: label,
    sizeDims: function (h, size) { var S = parseFloat(size); return h.ar >= 1 ? { w: S, l: Math.round(S / h.ar * 100) / 100 } : { w: Math.round(S * h.ar * 100) / 100, l: S }; }
  };
})();
